import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe, Facebook, Linkedin, Instagram, MessageCircle, ArrowRight } from "lucide-react";
import { useState } from "react";
import QuoteDialog from "@/components/QuoteDialog";
import { IMAGES } from "@/lib/site-data";

export default function Footer() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <footer className="bg-[#1e5ba8] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4 bg-white rounded-lg inline-flex h-24 w-40 items-center justify-center p-1">
              <img src={IMAGES.logo} alt="EXIMXPRESS" className="max-h-full max-w-full object-contain" />
            </div>
            <div className="text-[10px] text-white/70 tracking-[0.15em] font-medium mb-3">GLOBAL PRODUCE | TRUSTED EXPORTER</div>
            <p className="text-sm text-white/80 leading-relaxed">
              We export premium quality onions from India to the world with trust, quality and commitment.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[Facebook, Linkedin, Instagram, MessageCircle].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social"
                  className="w-9 h-9 rounded-full border border-white/25 flex items-center justify-center hover:bg-white hover:text-[#1e5ba8] transition-colors duration-200"
                  data-testid={`footer-social-${i}`}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">QUICK LINKS</h4>
            <ul className="space-y-2 text-sm text-white/85">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/products" className="hover:text-white">Products</Link></li>
              <li><Link to="/quality" className="hover:text-white">Quality</Link></li>
              <li><Link to="/markets" className="hover:text-white">Markets</Link></li>
              <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">PRODUCTS</h4>
            <ul className="space-y-2 text-sm text-white/85">
              <li><Link to="/products" className="hover:text-white">Fresh Red Onions</Link></li>
              <li><Link to="/products" className="hover:text-white">Nashik Onions</Link></li>
              <li><Link to="/products" className="hover:text-white">Pune Onions</Link></li>
              <li><Link to="/products" className="hover:text-white">Packed Onions</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">CONTACT US</h4>
            <ul className="space-y-3 text-sm text-white/85">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5" /> Office: Mumbai, India</li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> +91 9821170392</li>
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5" /> <span>info@eximxpress.com<br />sales@eximxpress.com</span></li>
              <li className="flex items-center gap-2"><Globe className="w-4 h-4" /> www.eximxpress.com</li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">GET IN TOUCH</h4>
            <p className="text-sm text-white/85 mb-4">Have a requirement?<br />We are ready to serve you.</p>
            <button
              onClick={() => setQuoteOpen(true)}
              className="inline-flex items-center gap-2 bg-white text-[#1e5ba8] font-semibold text-sm px-4 py-2 rounded-md hover:-translate-y-0.5 transition-transform duration-200"
              data-testid="footer-request-quote-btn"
            >
              REQUEST A QUOTE <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col md:flex-row items-center justify-between text-xs text-white/75 gap-2">
          <div data-testid="footer-copyright">© 2024 EXIMXPRESS. All Rights Reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms &amp; Conditions</a>
            <a href="#" className="hover:text-white">Sitemap</a>
          </div>
        </div>
      </div>

      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
    </footer>
  );
}
